import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import TermsPage from '@/pages/policy/TermsPage';
import Terms from '@/pages/policy/terms/Terms';
import Terms2 from '@/pages/policy/terms/Terms2';
import PrivacyPage from '@/pages/policy/PrivacyPage';
import Privacy from '@/pages/policy/privacy/Privacy';
import Email from '@/pages/policy/privacy/Email';

export const TermsRouter = {
	element: <TermsPage />,
	title: ROUTER_TITLES.POLICY.TERMS,
	children: [
		{
			path: ROUTER_PATH.POLICY.TERMS,
			element: <Terms />,
			title: ROUTER_TITLES.POLICY.TERMS
		},
		{
			path: ROUTER_PATH.POLICY.TERMS2,
			element: <Terms2 />,
			title: ROUTER_TITLES.POLICY.TERMS
		}
		// {
		// 	path: ROUTER_PATH.POLICY.TERMS_240214,
		// 	element: <Terms240214 />,
		// 	title: ROUTER_TITLES.POLICY.TERMS
		// }
	]
};

export const PrivacyRouter = {
	element: <PrivacyPage />,
	title: ROUTER_TITLES.POLICY.PRIVACY,
	children: [
		{
			path: ROUTER_PATH.POLICY.PRIVACY,
			element: <Privacy />,
			title: ROUTER_TITLES.POLICY.PRIVACY
		},
		// {
		// 	path: ROUTER_PATH.POLICY.PRIVACY_240214,
		// 	element: <Privacy240214 />,
		// 	title: ROUTER_TITLES.POLICY.PRIVACY
		// },
		{
			path: ROUTER_PATH.POLICY.PRIVACY_EMAIL,
			element: <Email />,
			title: ROUTER_TITLES.POLICY.PRIVACY_EMAIL
		}
	]
};
